import { render, staticRenderFns } from "./RecordStatus.vue?vue&type=template&id=6dc9b882"
import script from "./RecordStatus.vue?vue&type=script&lang=ts"
export * from "./RecordStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports